import React, { useEffect, useState } from "react";
import styles from "./Contacts.module.scss";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../PrivateRoute/PrivateRoute";
import { useNotification } from "../../../contexts/NotificationToast";
import { profileChangeData } from "../../../api/userApi";
import CustomButton from "../../CustomButton/CustomButton";
import CustomInput from "../../CustomInput/CustomInput";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const Contacts = () => {
  const { t } = useTranslation();
  const { userData, isLoading } = useAuth();
  const [phoneNum, setPhoneNum] = useState("");
  const { showNotification } = useNotification();

  useEffect(() => {
    if (!isLoading && userData?.phone_num) {
      setPhoneNum(userData.phone_num);
    }
  }, [isLoading, userData]);

  const handleSave = async () => {
    const updatedData = { phone_num: phoneNum };

    try {
      await profileChangeData(updatedData);

      showNotification("Successfully changed", 200);
    } catch (error) {
      showNotification("Error", 400);
    }
  };

  return (
    <div className={styles.contactsContainer}>
      <h2 className={styles.title}>{t("contacts.title")}</h2>

      <CustomInput label="Email" value={userData?.current_email} disabled />

      <div className={styles.phoneInputWrapper}>
        <label className={styles.inputLabel}>Phone</label>
        <PhoneInput
          placeholder="Enter phone number"
          value={phoneNum}
          onChange={setPhoneNum}
          defaultCountry="UA"
          international
          className={styles.phoneInput}
        />
      </div>

      <CustomButton
        blue
        width="300px"
        className={styles.saveButton}
        onClick={handleSave}
      >
        {t("saveButton")}
      </CustomButton>
    </div>
  );
};

export default Contacts;
